import { render, staticRenderFns } from "./PostActions.vue?vue&type=template&id=544845b4&"
import script from "./PostActions.vue?vue&type=script&lang=js&"
export * from "./PostActions.vue?vue&type=script&lang=js&"
import style0 from "./PostActions.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports